import { useEffect, useRef, useState } from "react";

const BOOT_LINES = [
    { text: "TIMBOTIC SYSTEMS", cls: "text-slate-900 font-bold" },
    { text: "INITIALISING...", cls: "text-slate-500" },
    { text: "", cls: "" },
    { label: "LAB NETWORK", status: "ONLINE", statusCls: "text-emerald-600" },
    { label: "AUTOMATION", status: "ONLINE", statusCls: "text-emerald-600" },
    { label: "TIMBOT", status: "ONLINE", statusCls: "text-emerald-600" },
    { label: "ROBOTICS LAB", status: "ONLINE", statusCls: "text-emerald-600" },
    { label: "COFFEE SUBSYSTEM", status: "DEGRADED", statusCls: "text-amber-600" },
    { text: "", cls: "" },
    { text: "LOADING QUESTIONABLE IDEAS...", cls: "text-cyan-600" },
    { text: "", cls: "" },
    { text: "TIMBOTIC READY", cls: "text-emerald-600 font-bold" },
];

const LINE_DELAY = 260;
const HOLD_AFTER_DONE = 700;
const FADE_MS = 600;

export default function BootSequence({ onDone }) {
    const [visibleCount, setVisibleCount] = useState(0);
    const [fading, setFading] = useState(false);
    const doneRef = useRef(false);

    const finish = () => {
        if (doneRef.current) return;
        doneRef.current = true;
        setFading(true);
        setTimeout(onDone, FADE_MS);
    };

    useEffect(() => {
        if (visibleCount < BOOT_LINES.length) {
            const t = setTimeout(() => setVisibleCount((c) => c + 1), LINE_DELAY);
            return () => clearTimeout(t);
        }
        const t = setTimeout(finish, HOLD_AFTER_DONE);
        return () => clearTimeout(t);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [visibleCount]);

    return (
        <div
            data-testid="boot-sequence"
            onClick={finish}
            className={`fixed inset-0 z-[100] bg-[#e2e8f0] flex items-center justify-center cursor-pointer transition-opacity duration-500 ${
                fading ? "opacity-0 pointer-events-none" : "opacity-100"
            }`}
        >
            <div className="w-full max-w-xl px-6 font-mono text-xs sm:text-sm leading-loose">
                {BOOT_LINES.slice(0, visibleCount).map((line, i) =>
                    line.label ? (
                        <div key={i} className="flex justify-between text-slate-600">
                            <span>
                                {line.label}
                                <span className="text-slate-600"> {".".repeat(Math.max(2, 22 - line.label.length))}</span>
                            </span>
                            <span className={line.statusCls}>{line.status}</span>
                        </div>
                    ) : (
                        <div key={i} className={line.cls}>
                            {line.text || "\u00A0"}
                        </div>
                    )
                )}
                <span className="inline-block w-2 h-4 bg-cyan-400 animate-caret align-middle" />
            </div>
            <div className="absolute bottom-6 right-6 font-mono text-[10px] text-slate-600 tracking-widest">
                CLICK TO SKIP
            </div>
        </div>
    );
}
